(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bsty-vehicle-paint"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bsty-vehicle-paint')) {
    customElements.define('bsty-vehicle-paint', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product-details') || this.parentElement;
        this.handleInput = (event) => {
          if (event.target.matches('input[required]')) {
            event.target.setCustomValidity(event.target.value.trim() ? '' : 'Please complete this field.');
          }
          this.syncPaintStatus();
        };
        this.handleSubmit = (event) => {
          if (event.target !== this.form) return;
          for (const input of this.querySelectorAll('input[required]')) {
            input.value = input.value.trim();
            input.setCustomValidity(input.value ? '' : 'Please complete this field.');
          }
          this.syncPaintStatus();
          if (!this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.addEventListener('input', this.handleInput);
        this.scope.addEventListener('submit', this.handleSubmit, true);
        this.bindForm();
        this.observer = new MutationObserver(() => this.bindForm());
        this.observer.observe(this.scope, { childList: true, subtree: true });
      }
      bindForm() {
        const form = this.scope.querySelector('product-form-component form[action*="/cart/add"]') || document.getElementById(this.dataset.formId);
        if (!form) return;
        if (!form.id) form.id = this.dataset.formId;
        this.form = form;
        for (const input of this.querySelectorAll('input[name^="properties["]')) {
          if (input.getAttribute('form') !== form.id) input.setAttribute('form', form.id);
        }
        this.syncPaintStatus();
      }
      syncPaintStatus() {
        const paintInput = this.querySelector('[data-paint-input]');
        const pendingInput = this.querySelector('[data-paint-pending]');
        if (paintInput && pendingInput) pendingInput.disabled = Boolean(paintInput.value.trim());
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('input', this.handleInput);
        this.scope?.removeEventListener('submit', this.handleSubmit, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
